import axios from 'axios';
import IMask from 'imask/esm/imask';
import 'imask/esm/masked/number';
import makeBazarOrder from './makeBazarOrder';
import makeOilspotOrder from './makeOilspotOrder';
import htmlToDom from '../../helpers/htmlToDom';
import Orders from '../../services/Orders';
import configs from '../../globals/configs';

export default () =>
{
	const state =
	{
		isPhoneInput: true,
		phone: null,
	};

	const orderHistoryLink = document.querySelectorAll('.orderHistory');
	const orderHistoryModal = document.querySelector('.modal.modal-history');
	const orderHistoryClose = document.querySelector(
		'.modal-history .modal__header-close'
	);
	const orderHistoryBtn = document.querySelector('.order-history__btn-link');
	const orderHistoryBtnCode = document.querySelector(
		'.order-history__btn-code'
	);
	const orderHistoryInputBlock = document.querySelector(
		'.order-history__input-block'
	);
	const orderHistoryLabel = document.querySelector(
		'.order-history__input-label'
	);
	const orderHistoryInput = document.querySelector('#order-history-input');
	let maskInput = IMask(orderHistoryInput, {mask: '+7 (000)000-00-00', lazy: false});
	const orderHistoryTimerBlock = document.querySelector(
		'.order-history__input-timer'
	);
	const orderHistoryTimer = document.querySelector('.order-history-timer');
	const orderHistoryList = document.querySelector('.order-history__list');

	let time;
	const timeout = 30; // sec
	let timerInterval = null;

	function open() { orderHistoryModal.classList.add('modal--show'); }

	function close() { orderHistoryModal.classList.remove('modal--show'); }

	function stopTimer()
	{
		clearInterval(timerInterval);
		orderHistoryTimer.textContent = '00:29';
		orderHistoryTimerBlock.classList.remove('active');
	}

	function timer()
	{
		orderHistoryTimerBlock.classList.add('active');

		const countDownDate = (time + timeout) * 1000;
		timerInterval = setInterval(() =>
		{
			const now = new Date().getTime();
			const distance = countDownDate - now;
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((distance % (1000 * 60)) / 1000);

			const timeMoment = `0${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
			orderHistoryTimer.textContent = timeMoment;

			if (distance < 0)
			{
				orderHistoryBtnCode.classList.add('show');
				stopTimer();
			}
		}, 1000);
	}

	function setCodeInput()
	{
		orderHistoryLabel.textContent = 'Код';
		orderHistoryInput.placeholder = 'Введите код из смс';
		orderHistoryInput.value = '';
		maskInput.updateValue();
		maskInput.destroy();
		maskInput = IMask(orderHistoryInput, {mask: '0000'})
		timer();
		state.isPhoneInput = false;
	}

	function setPhoneInput()
	{
		orderHistoryLabel.textContent = 'Номер телефона';
		orderHistoryInput.placeholder = 'Введите номер телефона';

		maskInput.updateOptions({mask: '+7 (000)000-00-00', lazy: false });

		orderHistoryInput.setAttribute('maxlength', 18);
		if (state.phone)
		{
			orderHistoryBtn.removeAttribute('disabled');
			orderHistoryInput.value = state.phone;
			maskInput.updateValue();
		}
		else
		{
			orderHistoryInput.value = '';
			maskInput.updateValue();
		}
	}

	function successRequestCode(data)
	{
		if (data.error)
			alert(data.message);
		else
		{
			time = Math.floor(Date.now() / 1000);
			setCodeInput();
		}
	}

	function successRequestOrders(data)
	{
		if (!data.error && (data.message['bazar'] || data.message['oilspot']))
		{
			let sales;
			if (data.message['bazar'])
			{
				sales = data.message['bazar']['sales'];
				if (sales && sales.length)
				{
					stopTimer();
					const salesEls = sales.reverse().map(makeBazarOrder);
					salesEls.forEach((htmlString) =>
					{
						const listItem = htmlToDom(htmlString);
						orderHistoryList.append(listItem);
					});
				}
			}
			if (data.message['oilspot'])
			{
				sales = data.message["oilspot"];
				if (sales && sales.length)
				{
					stopTimer();
					const salesEls = sales.reverse().map(makeOilspotOrder);
					salesEls.forEach((htmlString) =>
					{
						const listItem = htmlToDom(htmlString);
						orderHistoryList.append(listItem);
					});
				}
			}
			if (sales && !sales.length)
				alert('По данному номеру заказы не найдены');
		}
		else if (!data.error && !data.message)
			alert('По данному номеру ничего не найдено.');
		else
			alert(data.message);
	}

	function requestCode(phone)
	{
		const formData = new FormData();
		formData.append('phone', phone);
		axios.post('/orderHistory/getcode', formData, {headers:{'Content-Type': 'multipart/form-data'}})
		.then(successRequestCode)
		.catch((error) => { console.log('Error ' + error.message) });
	}

	function requestOrders(code)
	{
		orderHistoryInputBlock.classList.add('hide');
		Orders.fetchOrders(code).then(successRequestOrders);
	}

	orderHistoryLink.forEach((el) =>
	{
		el.addEventListener('click', (e) =>
		{
			e.preventDefault();
			open();
		});
	});

	document.body.addEventListener('click', (e) =>
	{
		const isModalBackdropClicked = e.target.closest('.modal-history') && !e.target.closest('.modal__content');

		if (isModalBackdropClicked)
			close();
	});

	orderHistoryClose.addEventListener('click', close);

	orderHistoryInput.addEventListener('input', () =>
	{
		if (state.isPhoneInput)
		{
			if (orderHistoryInput.value === '8')
				orderHistoryInput.value = '+7 (';

			if (maskInput.unmaskedValue.length === 10)
				orderHistoryBtn.removeAttribute('disabled');
			else
				orderHistoryBtn.setAttribute('disabled', 'disabled');
		}
		else if (maskInput.unmaskedValue.length === 3)
			orderHistoryBtn.removeAttribute('disabled');
		else
			orderHistoryBtn.setAttribute('disabled', 'disabled');
	});

	orderHistoryBtn.addEventListener('click', () =>
	{
		if (state.isPhoneInput)
		{
			state.phone = orderHistoryInput.value;
			state.isPhoneInput = false;
			orderHistoryInput.setAttribute('maxlength', 4);
			orderHistoryBtn.setAttribute('disabled', 'disabled');
			requestCode(state.phone);
		}
		else
			requestOrders(maskInput.unmaskedValue);
	});

	orderHistoryBtnCode.addEventListener('click', () =>
	{
		orderHistoryBtnCode.classList.remove('show');
		setPhoneInput();
	});
};
